import { render, staticRenderFns } from "./MarketInfosBox.vue?vue&type=template&id=ba124df4&"
import script from "./MarketInfosBox.vue?vue&type=script&lang=js&"
export * from "./MarketInfosBox.vue?vue&type=script&lang=js&"
import style0 from "./MarketInfosBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports